"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const schema_1 = __importDefault(require("./schema"));
const uiSchema_1 = __importDefault(require("./uiSchema"));
const initialData_1 = __importDefault(require("./initialData"));
const formToPayloadDataHandler_1 = require("./formToPayloadDataHandler");
const payloadToFormDataHandler_1 = require("./payloadToFormDataHandler");
const aideLastVisitTemplate = {
    schema: schema_1.default,
    uiSchema: uiSchema_1.default,
    initialData: initialData_1.default,
    formToPayloadDataHandler: formToPayloadDataHandler_1.aideLastVisitFormToPayloadDataHandler,
    payloadToFormDataHandler: payloadToFormDataHandler_1.aideLastVisitPayloadToFormDataHandler,
};
exports.default = aideLastVisitTemplate;
